module.exports = __webpack_public_path__ + "static/marketing-websites-6e6ee93e1f42dae6a8647e3fe1538034.svg";